import { modalBibliographySearchHistoryStore } from '@/store'
import { ModalBibliographySearchHistoryStoreInterface } from '@/store/ModalBibliographySearchHistoryStore'

export class ModalBibliographySearchHistoryService {
  public open(params: ModalBibliographySearchHistoryStoreInterface) {
    modalBibliographySearchHistoryStore.open(params)
  }

  public close() {
    modalBibliographySearchHistoryStore.close()
  }
}
